import { teamsAdministrationTeamQueryOptions } from '@features/portal-tools/sub-features/teams-administration/queries'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/tools/teams-administration/teams/$teamId')({
    component: RouteComponent,
    loader: ({ params, context }) =>
        context.queryClient.ensureQueryData(teamsAdministrationTeamQueryOptions(params.teamId)),
    staticData: {
        crumb: {
            label: (match) => match.loaderData?.displayName ?? match.params.teamId
        }
    }
})

function RouteComponent() {
  return <Outlet />
}
